export class UpfrontAmountPresentation {
  constructor(
    public readonly currency: string,
    public readonly amount: number,
  ) {
  }
}
